import React from "react";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";

interface GoogleSignInButtonProps {
  onSuccess: (credentialResponse: any) => void;
  onError: () => void;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onSuccess,
  onError,
}) => {
  const { t } = useTranslation("common");
  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || ""}
    >
      <Box
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          // @ts-ignore
          text={t("google.googleSignUp")}
          style={{
            margin: "0 auto",
            display: "block",
            width: "100%",
          }}
        />
      </Box>
    </GoogleOAuthProvider>
  );
};
